/**
 * Lumora Theme - Main JavaScript
 * Handles interactive components: cart drawer, mobile nav, tabs, carousels
 */

(function () {
  'use strict';

  /* ========================
     Cart Drawer
     ======================== */
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartClose = document.querySelector('[data-cart-close]');
  const cartOverlay = document.querySelector('[data-cart-overlay]');

  function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
  }

  function renderCartDrawer(cart) {
  var body = document.querySelector('[data-cart-body]');
  if (!body) return;
  if (cart.item_count > 0) {
  var itemsHtml = '<div class="cart-drawer__items">';
  cart.items.forEach(function (item) {
  itemsHtml += '<div class="cart-drawer__item" data-cart-item="' + item.key + '">';
  itemsHtml += '<div class="cart-drawer__item-media">';
  if (item.image) { itemsHtml += '<img src="' + item.image + '&width=120" alt="" width="120" height="120" loading="lazy">'; }
  itemsHtml += '</div>';
  itemsHtml += '<div class="cart-drawer__item-info">';
  itemsHtml += '<a href="' + item.url + '" class="cart-drawer__item-title">' + item.product_title + '</a>';
  if (item.variant_title && item.variant_title !== 'Default Title') { itemsHtml += '<p class="cart-drawer__item-variant">' + item.variant_title + '</p>'; }
  itemsHtml += '<div class="cart-drawer__item-quantity">';
  itemsHtml += '<button type="button" class="cart-drawer__qty-btn" data-qty-change="' + item.key + '" data-qty-direction="minus">−</button>';
  itemsHtml += '<span class="cart-drawer__qty-value">' + item.quantity + '</span>';
  itemsHtml += '<button type="button" class="cart-drawer__qty-btn" data-qty-change="' + item.key + '" data-qty-direction="plus">+</button>';
  itemsHtml += '</div>';
  itemsHtml += '</div>';
  itemsHtml += '<div class="cart-drawer__item-price">';
  itemsHtml += '<span>' + formatMoney(item.final_line_price) + '</span>';
  itemsHtml += '<button type="button" class="cart-drawer__item-remove" data-remove-item="' + item.key + '" aria-label="Remove ' + item.product_title + '">Remove</button>';
  itemsHtml += '</div>';
  itemsHtml += '</div>';
  });
  itemsHtml += '</div>';
  body.innerHTML = itemsHtml;
  } else {
  body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn btn--secondary">Continue Shopping</a></div>';
  }
  var footer = document.querySelector('[data-cart-footer]');
  var subtotalEl = document.querySelector('[data-cart-subtotal]');
  if (cart.item_count > 0) {
  if (subtotalEl) { subtotalEl.textContent = formatMoney(cart.total_price); }
  if (footer) { footer.style.display = ''; }
  } else {
  if (footer) { footer.style.display = 'none'; }
  }
  bindCartItemEvents();
  }

  function bindCartItemEvents() {
  document.querySelectorAll('[data-qty-change]').forEach(function (btn) {
  btn.addEventListener('click', function () {
  var key = this.getAttribute('data-qty-change');
  var direction = this.getAttribute('data-qty-direction');
  var valueEl = this.parentElement.querySelector('.cart-drawer__qty-value');
  var qty = parseInt(valueEl.textContent, 10);
  qty = direction === 'plus' ? qty + 1 : qty - 1;
  if (qty < 0) qty = 0;
  fetch('/cart/change.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(function (r) { return r.json(); })
  .then(function (cart) {
  var countEl = document.querySelector('[data-cart-count]');
  if (countEl) { countEl.textContent = cart.item_count; }
  renderCartDrawer(cart);
  });
  });
  });
  document.querySelectorAll('[data-remove-item]').forEach(function (btn) {
  btn.addEventListener('click', function () {
  var key = this.getAttribute('data-remove-item');
  fetch('/cart/change.js', {
  method: 'POST',
  headers: { 'Content-Type': 'application/json' },
  body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(function (r) { return r.json(); })
  .then(function (cart) {
  var countEl = document.querySelector('[data-cart-count]');
  if (countEl) { countEl.textContent = cart.item_count; }
  renderCartDrawer(cart);
  });
  });
  });
  }

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      cartDrawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('is-open');
      cartDrawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ========================
     Mobile Navigation
     ======================== */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const menuClose = document.querySelector('[data-menu-close]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  function openMobileNav() {
    if (mobileNav) {
      mobileNav.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeMobileNav() {
    if (mobileNav) {
      mobileNav.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileNav);
  if (menuClose) menuClose.addEventListener('click', closeMobileNav);

  /* ========================
     Collection Tabs
     ======================== */
  document.querySelectorAll('[data-tab-trigger]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      const targetId = this.getAttribute('data-tab-trigger');
      const section = this.closest('.collection-tabs');

      // Update tab states
      section.querySelectorAll('[data-tab-trigger]').forEach(function (t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      this.classList.add('is-active');
      this.setAttribute('aria-selected', 'true');

      // Update panel states
      section.querySelectorAll('[data-tab-panel]').forEach(function (panel) {
        panel.classList.remove('is-active');
      });
      var targetPanel = section.querySelector('[data-tab-panel="' + targetId + '"]');
      if (targetPanel) targetPanel.classList.add('is-active');
    });
  });

  /* ========================
     Carousel Navigation
     ======================== */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    const track = carousel.querySelector('.featured-carousel__slides') ||
                  carousel.querySelector('.reviews-carousel__track');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');

    if (!track) return;

    const scrollAmount = 300;

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });
    }
  });

  /* ========================
     Product Page - Variant Selection
     ======================== */
  document.querySelectorAll('[data-option-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      const form = this.closest('form');
      if (!form) return;

      // Update swatch active states
      const optionGroup = this.closest('.product-page__option-values');
      optionGroup.querySelectorAll('.product-page__swatch').forEach(function (swatch) {
        swatch.classList.remove('is-selected');
      });
      this.closest('.product-page__swatch').classList.add('is-selected');

      // Find matching variant
      const selects = form.querySelectorAll('[data-option-input]:checked');
      const selectedOptions = Array.from(selects).map(function (s) { return s.value; });
      const variantSelect = form.querySelector('[data-variant-select]');

      if (variantSelect) {
        Array.from(variantSelect.options).forEach(function (option) {
          const optionTitle = option.getAttribute('data-variant-option');
          if (optionTitle && selectedOptions.every(function (opt) { return optionTitle.includes(opt); })) {
            variantSelect.value = option.value;
          }
        });
        // Update price and image from selected variant
        var selectedOption = variantSelect.options[variantSelect.selectedIndex];
        if (selectedOption) {
        var priceEl = document.querySelector('[data-product-price]');
        var priceVal = selectedOption.getAttribute('data-variant-price');
        if (priceEl && priceVal) { priceEl.textContent = priceVal; }
        var comparePriceEl = document.querySelector('[data-product-compare-price]');
        if (comparePriceEl) {
        var compareVal = selectedOption.getAttribute('data-variant-compare-price');
        if (compareVal) { comparePriceEl.textContent = compareVal; comparePriceEl.style.display = ''; } else { comparePriceEl.style.display = 'none'; }
        }
var mediaId = selectedOption.getAttribute('data-variant-media-id');
        var gallery = form.querySelector('.product-page__media') || document.querySelector('.product-page__media');
                var targetMedia = mediaId && gallery ? gallery.querySelector('[data-media-id="' + mediaId + '"]') : null;
                        if (targetMedia) {
                                gallery.querySelectorAll('.product-page__media-item').forEach(function (item) { item.classList.remove('is-active'); });
                                        targetMedia.classList.add('is-active');
                                                gallery.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
                                                        var targetThumb = gallery.querySelector('[data-thumb="' + mediaId + '"]');
                                                                if (targetThumb) { targetThumb.classList.add('is-active'); }
                                                                        } else {
                                                                                var imageUrl = selectedOption.getAttribute('data-variant-image');
                                                                                        if (imageUrl) {
                                                                                                var mainImage = document.querySelector('.product-page__media-item.is-active img[data-product-main-image]');
                                                                                                        if (mainImage) {
                                                                                                                mainImage.src = imageUrl;
                                                                                                                        var imageAlt = selectedOption.getAttribute('data-variant-image-alt');
                                                                                                                                if (imageAlt) { mainImage.alt = imageAlt; }
                                                                                                                                        }
                                                                                                                                                }
                                                                                                                                                        }
        }
      }
    });
  });

  /* ========================
     Product Page - Media Gallery
     ======================== */
  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const mediaId = this.getAttribute('data-thumb');
      const section = this.closest('.product-page__media');

      // Update thumb states
      section.querySelectorAll('[data-thumb]').forEach(function (t) {
        t.classList.remove('is-active');
      });
      this.classList.add('is-active');

      // Update media states
      section.querySelectorAll('.product-page__media-item').forEach(function (item) {
        item.classList.remove('is-active');
      });
      var target = section.querySelector('[data-media-id="' + mediaId + '"]');
      if (target) target.classList.add('is-active');

      // Sync matching color swatch, if any
      var productForm = document.querySelector('[data-product-form]');
      var syncInput = productForm ? productForm.querySelector('[data-swatch-media-id="' + mediaId + '"]') : null;
      if (syncInput && !syncInput.checked) {
      syncInput.checked = true;
      syncInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  /* ========================
     Quantity Buttons
     ======================== */
  document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('.product-page__qty-input');
      if (input && parseInt(input.value) > 1) {
        input.value = parseInt(input.value) - 1;
      }
    });
  });

  document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const input = this.parentElement.querySelector('.product-page__qty-input');
      if (input) {
        input.value = parseInt(input.value) + 1;
      }
    });
  });

  /* ========================
     Collection Sort
     ======================== */
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ========================
     Product Form - AJAX Add to Cart
     ======================== */
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const formData = new FormData(this);
      const submitBtn = this.querySelector('[type="submit"]');
      const originalText = submitBtn.textContent;

      submitBtn.textContent = 'Adding...';
      submitBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          submitBtn.textContent = 'Added!';
          setTimeout(function () {
            submitBtn.textContent = originalText;
            submitBtn.disabled = false;
          }, 2000);

          // Update cart count
          fetch('/cart.js')
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              var countEl = document.querySelector('[data-cart-count]');
              if (countEl) countEl.textContent = cart.item_count;
              renderCartDrawer(cart);
            });

          // Open cart drawer
          openCart();
        })
        .catch(function (error) {
          console.error('Error adding to cart:', error);
          submitBtn.textContent = originalText;
          submitBtn.disabled = false;
        });
    });
  });

  /* ========================
     Review Filters
     ======================== */
  document.querySelectorAll('[data-filter]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const filter = this.getAttribute('data-filter');
      const section = this.closest('.reviews-carousel');

      // Update filter button states
      section.querySelectorAll('[data-filter]').forEach(function (b) {
        b.classList.remove('is-active');
      });
      this.classList.add('is-active');

      // Filter reviews
      section.querySelectorAll('.reviews-carousel__slide').forEach(function (slide) {
        const tags = slide.getAttribute('data-tags') || '';
        if (tags.includes(filter)) {
          slide.style.display = '';
        } else {
          slide.style.display = 'none';
        }
      });
    });
  });

  /* ========================
     Sticky Header
     ======================== */
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', function () {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 100) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
      lastScroll = currentScroll;
    });
  }

})();
